/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as WorkspaceSlugRouteImport } from './routes/$workspaceSlug'
import { Route as IndexRouteImport } from './routes/index'
import { Route as WorkspaceSlugIndexRouteImport } from './routes/$workspaceSlug/index'
import { Route as InviteInviteIdRouteImport } from './routes/invite/$inviteId'
import { Route as WorkspaceSlugCalendarRouteImport } from './routes/$workspaceSlug/calendar'
import { Route as WorkspaceSlugTimeTrackerIndexRouteImport } from './routes/$workspaceSlug/time-tracker/index'
import { Route as WorkspaceSlugTeamIndexRouteImport } from './routes/$workspaceSlug/team/index'
import { Route as WorkspaceSlugProjectsIndexRouteImport } from './routes/$workspaceSlug/projects/index'
import { Route as WorkspaceSlugProfileIndexRouteImport } from './routes/$workspaceSlug/profile/index'
import { Route as WorkspaceSlugMyTasksIndexRouteImport } from './routes/$workspaceSlug/my-tasks/index'
import { Route as WorkspaceSlugMessagesIndexRouteImport } from './routes/$workspaceSlug/messages/index'
import { Route as WorkspaceSlugFilesIndexRouteImport } from './routes/$workspaceSlug/files/index'
import { Route as WorkspaceSlugDocsIndexRouteImport } from './routes/$workspaceSlug/docs/index'
import { Route as WorkspaceSlugBoardIndexRouteImport } from './routes/$workspaceSlug/board/index'
import { Route as WorkspaceSlugProjectsProjectIdIndexRouteImport } from './routes/$workspaceSlug/projects/$projectId/index'

const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkspaceSlugRoute = WorkspaceSlugRouteImport.update({
  id: '/$workspaceSlug',
  path: '/$workspaceSlug',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkspaceSlugIndexRoute = WorkspaceSlugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WorkspaceSlugRoute,
} as any)
const InviteInviteIdRoute = InviteInviteIdRouteImport.update({
  id: '/invite/$inviteId',
  path: '/invite/$inviteId',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkspaceSlugCalendarRoute = WorkspaceSlugCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => WorkspaceSlugRoute,
} as any)
const WorkspaceSlugTimeTrackerIndexRoute =
  WorkspaceSlugTimeTrackerIndexRouteImport.update({
    id: '/time-tracker/',
    path: '/time-tracker/',
    getParentRoute: () => WorkspaceSlugRoute,
  } as any)
const WorkspaceSlugTeamIndexRoute = WorkspaceSlugTeamIndexRouteImport.update({
  id: '/team/',
  path: '/team/',
  getParentRoute: () => WorkspaceSlugRoute,
} as any)
const WorkspaceSlugProjectsIndexRoute =
  WorkspaceSlugProjectsIndexRouteImport.update({
    id: '/projects/',
    path: '/projects/',
    getParentRoute: () => WorkspaceSlugRoute,
  } as any)
const WorkspaceSlugProfileIndexRoute =
  WorkspaceSlugProfileIndexRouteImport.update({
    id: '/profile/',
    path: '/profile/',
    getParentRoute: () => WorkspaceSlugRoute,
  } as any)
const WorkspaceSlugMyTasksIndexRoute =
  WorkspaceSlugMyTasksIndexRouteImport.update({
    id: '/my-tasks/',
    path: '/my-tasks/',
    getParentRoute: () => WorkspaceSlugRoute,
  } as any)
const WorkspaceSlugMessagesIndexRoute =
  WorkspaceSlugMessagesIndexRouteImport.update({
    id: '/messages/',
    path: '/messages/',
    getParentRoute: () => WorkspaceSlugRoute,
  } as any)
const WorkspaceSlugFilesIndexRoute = WorkspaceSlugFilesIndexRouteImport.update({
  id: '/files/',
  path: '/files/',
  getParentRoute: () => WorkspaceSlugRoute,
} as any)
const WorkspaceSlugDocsIndexRoute = WorkspaceSlugDocsIndexRouteImport.update({
  id: '/docs/',
  path: '/docs/',
  getParentRoute: () => WorkspaceSlugRoute,
} as any)
const WorkspaceSlugBoardIndexRoute = WorkspaceSlugBoardIndexRouteImport.update({
  id: '/board/',
  path: '/board/',
  getParentRoute: () => WorkspaceSlugRoute,
} as any)
const WorkspaceSlugProjectsProjectIdIndexRoute =
  WorkspaceSlugProjectsProjectIdIndexRouteImport.update({
    id: '/projects/$projectId/',
    path: '/projects/$projectId/',
    getParentRoute: () => WorkspaceSlugRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$workspaceSlug': typeof WorkspaceSlugRouteWithChildren
  '/dashboard': typeof DashboardRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/$workspaceSlug/calendar': typeof WorkspaceSlugCalendarRoute
  '/invite/$inviteId': typeof InviteInviteIdRoute
  '/$workspaceSlug/': typeof WorkspaceSlugIndexRoute
  '/$workspaceSlug/board/': typeof WorkspaceSlugBoardIndexRoute
  '/$workspaceSlug/docs/': typeof WorkspaceSlugDocsIndexRoute
  '/$workspaceSlug/files/': typeof WorkspaceSlugFilesIndexRoute
  '/$workspaceSlug/messages/': typeof WorkspaceSlugMessagesIndexRoute
  '/$workspaceSlug/my-tasks/': typeof WorkspaceSlugMyTasksIndexRoute
  '/$workspaceSlug/profile/': typeof WorkspaceSlugProfileIndexRoute
  '/$workspaceSlug/projects/': typeof WorkspaceSlugProjectsIndexRoute
  '/$workspaceSlug/team/': typeof WorkspaceSlugTeamIndexRoute
  '/$workspaceSlug/time-tracker/': typeof WorkspaceSlugTimeTrackerIndexRoute
  '/$workspaceSlug/projects/$projectId/': typeof WorkspaceSlugProjectsProjectIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/$workspaceSlug/calendar': typeof WorkspaceSlugCalendarRoute
  '/invite/$inviteId': typeof InviteInviteIdRoute
  '/$workspaceSlug': typeof WorkspaceSlugIndexRoute
  '/$workspaceSlug/board': typeof WorkspaceSlugBoardIndexRoute
  '/$workspaceSlug/docs': typeof WorkspaceSlugDocsIndexRoute
  '/$workspaceSlug/files': typeof WorkspaceSlugFilesIndexRoute
  '/$workspaceSlug/messages': typeof WorkspaceSlugMessagesIndexRoute
  '/$workspaceSlug/my-tasks': typeof WorkspaceSlugMyTasksIndexRoute
  '/$workspaceSlug/profile': typeof WorkspaceSlugProfileIndexRoute
  '/$workspaceSlug/projects': typeof WorkspaceSlugProjectsIndexRoute
  '/$workspaceSlug/team': typeof WorkspaceSlugTeamIndexRoute
  '/$workspaceSlug/time-tracker': typeof WorkspaceSlugTimeTrackerIndexRoute
  '/$workspaceSlug/projects/$projectId': typeof WorkspaceSlugProjectsProjectIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$workspaceSlug': typeof WorkspaceSlugRouteWithChildren
  '/dashboard': typeof DashboardRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/$workspaceSlug/calendar': typeof WorkspaceSlugCalendarRoute
  '/invite/$inviteId': typeof InviteInviteIdRoute
  '/$workspaceSlug/': typeof WorkspaceSlugIndexRoute
  '/$workspaceSlug/board/': typeof WorkspaceSlugBoardIndexRoute
  '/$workspaceSlug/docs/': typeof WorkspaceSlugDocsIndexRoute
  '/$workspaceSlug/files/': typeof WorkspaceSlugFilesIndexRoute
  '/$workspaceSlug/messages/': typeof WorkspaceSlugMessagesIndexRoute
  '/$workspaceSlug/my-tasks/': typeof WorkspaceSlugMyTasksIndexRoute
  '/$workspaceSlug/profile/': typeof WorkspaceSlugProfileIndexRoute
  '/$workspaceSlug/projects/': typeof WorkspaceSlugProjectsIndexRoute
  '/$workspaceSlug/team/': typeof WorkspaceSlugTeamIndexRoute
  '/$workspaceSlug/time-tracker/': typeof WorkspaceSlugTimeTrackerIndexRoute
  '/$workspaceSlug/projects/$projectId/': typeof WorkspaceSlugProjectsProjectIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$workspaceSlug'
    | '/dashboard'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/$workspaceSlug/calendar'
    | '/invite/$inviteId'
    | '/$workspaceSlug/'
    | '/$workspaceSlug/board/'
    | '/$workspaceSlug/docs/'
    | '/$workspaceSlug/files/'
    | '/$workspaceSlug/messages/'
    | '/$workspaceSlug/my-tasks/'
    | '/$workspaceSlug/profile/'
    | '/$workspaceSlug/projects/'
    | '/$workspaceSlug/team/'
    | '/$workspaceSlug/time-tracker/'
    | '/$workspaceSlug/projects/$projectId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/dashboard'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/$workspaceSlug/calendar'
    | '/invite/$inviteId'
    | '/$workspaceSlug'
    | '/$workspaceSlug/board'
    | '/$workspaceSlug/docs'
    | '/$workspaceSlug/files'
    | '/$workspaceSlug/messages'
    | '/$workspaceSlug/my-tasks'
    | '/$workspaceSlug/profile'
    | '/$workspaceSlug/projects'
    | '/$workspaceSlug/team'
    | '/$workspaceSlug/time-tracker'
    | '/$workspaceSlug/projects/$projectId'
  id:
    | '__root__'
    | '/'
    | '/$workspaceSlug'
    | '/dashboard'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/$workspaceSlug/calendar'
    | '/invite/$inviteId'
    | '/$workspaceSlug/'
    | '/$workspaceSlug/board/'
    | '/$workspaceSlug/docs/'
    | '/$workspaceSlug/files/'
    | '/$workspaceSlug/messages/'
    | '/$workspaceSlug/my-tasks/'
    | '/$workspaceSlug/profile/'
    | '/$workspaceSlug/projects/'
    | '/$workspaceSlug/team/'
    | '/$workspaceSlug/time-tracker/'
    | '/$workspaceSlug/projects/$projectId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  WorkspaceSlugRoute: typeof WorkspaceSlugRouteWithChildren
  DashboardRoute: typeof DashboardRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  RegisterRoute: typeof RegisterRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  InviteInviteIdRoute: typeof InviteInviteIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$workspaceSlug': {
      id: '/$workspaceSlug'
      path: '/$workspaceSlug'
      fullPath: '/$workspaceSlug'
      preLoaderRoute: typeof WorkspaceSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$workspaceSlug/': {
      id: '/$workspaceSlug/'
      path: '/'
      fullPath: '/$workspaceSlug/'
      preLoaderRoute: typeof WorkspaceSlugIndexRouteImport
      parentRoute: typeof WorkspaceSlugRoute
    }
    '/invite/$inviteId': {
      id: '/invite/$inviteId'
      path: '/invite/$inviteId'
      fullPath: '/invite/$inviteId'
      preLoaderRoute: typeof InviteInviteIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$workspaceSlug/calendar': {
      id: '/$workspaceSlug/calendar'
      path: '/calendar'
      fullPath: '/$workspaceSlug/calendar'
      preLoaderRoute: typeof WorkspaceSlugCalendarRouteImport
      parentRoute: typeof WorkspaceSlugRoute
    }
    '/$workspaceSlug/time-tracker/': {
      id: '/$workspaceSlug/time-tracker/'
      path: '/time-tracker'
      fullPath: '/$workspaceSlug/time-tracker/'
      preLoaderRoute: typeof WorkspaceSlugTimeTrackerIndexRouteImport
      parentRoute: typeof WorkspaceSlugRoute
    }
    '/$workspaceSlug/team/': {
      id: '/$workspaceSlug/team/'
      path: '/team'
      fullPath: '/$workspaceSlug/team/'
      preLoaderRoute: typeof WorkspaceSlugTeamIndexRouteImport
      parentRoute: typeof WorkspaceSlugRoute
    }
    '/$workspaceSlug/projects/': {
      id: '/$workspaceSlug/projects/'
      path: '/projects'
      fullPath: '/$workspaceSlug/projects/'
      preLoaderRoute: typeof WorkspaceSlugProjectsIndexRouteImport
      parentRoute: typeof WorkspaceSlugRoute
    }
    '/$workspaceSlug/profile/': {
      id: '/$workspaceSlug/profile/'
      path: '/profile'
      fullPath: '/$workspaceSlug/profile/'
      preLoaderRoute: typeof WorkspaceSlugProfileIndexRouteImport
      parentRoute: typeof WorkspaceSlugRoute
    }
    '/$workspaceSlug/my-tasks/': {
      id: '/$workspaceSlug/my-tasks/'
      path: '/my-tasks'
      fullPath: '/$workspaceSlug/my-tasks/'
      preLoaderRoute: typeof WorkspaceSlugMyTasksIndexRouteImport
      parentRoute: typeof WorkspaceSlugRoute
    }
    '/$workspaceSlug/messages/': {
      id: '/$workspaceSlug/messages/'
      path: '/messages'
      fullPath: '/$workspaceSlug/messages/'
      preLoaderRoute: typeof WorkspaceSlugMessagesIndexRouteImport
      parentRoute: typeof WorkspaceSlugRoute
    }
    '/$workspaceSlug/files/': {
      id: '/$workspaceSlug/files/'
      path: '/files'
      fullPath: '/$workspaceSlug/files/'
      preLoaderRoute: typeof WorkspaceSlugFilesIndexRouteImport
      parentRoute: typeof WorkspaceSlugRoute
    }
    '/$workspaceSlug/docs/': {
      id: '/$workspaceSlug/docs/'
      path: '/docs'
      fullPath: '/$workspaceSlug/docs/'
      preLoaderRoute: typeof WorkspaceSlugDocsIndexRouteImport
      parentRoute: typeof WorkspaceSlugRoute
    }
    '/$workspaceSlug/board/': {
      id: '/$workspaceSlug/board/'
      path: '/board'
      fullPath: '/$workspaceSlug/board/'
      preLoaderRoute: typeof WorkspaceSlugBoardIndexRouteImport
      parentRoute: typeof WorkspaceSlugRoute
    }
    '/$workspaceSlug/projects/$projectId/': {
      id: '/$workspaceSlug/projects/$projectId/'
      path: '/projects/$projectId'
      fullPath: '/$workspaceSlug/projects/$projectId/'
      preLoaderRoute: typeof WorkspaceSlugProjectsProjectIdIndexRouteImport
      parentRoute: typeof WorkspaceSlugRoute
    }
  }
}

interface WorkspaceSlugRouteChildren {
  WorkspaceSlugCalendarRoute: typeof WorkspaceSlugCalendarRoute
  WorkspaceSlugIndexRoute: typeof WorkspaceSlugIndexRoute
  WorkspaceSlugBoardIndexRoute: typeof WorkspaceSlugBoardIndexRoute
  WorkspaceSlugDocsIndexRoute: typeof WorkspaceSlugDocsIndexRoute
  WorkspaceSlugFilesIndexRoute: typeof WorkspaceSlugFilesIndexRoute
  WorkspaceSlugMessagesIndexRoute: typeof WorkspaceSlugMessagesIndexRoute
  WorkspaceSlugMyTasksIndexRoute: typeof WorkspaceSlugMyTasksIndexRoute
  WorkspaceSlugProfileIndexRoute: typeof WorkspaceSlugProfileIndexRoute
  WorkspaceSlugProjectsIndexRoute: typeof WorkspaceSlugProjectsIndexRoute
  WorkspaceSlugTeamIndexRoute: typeof WorkspaceSlugTeamIndexRoute
  WorkspaceSlugTimeTrackerIndexRoute: typeof WorkspaceSlugTimeTrackerIndexRoute
  WorkspaceSlugProjectsProjectIdIndexRoute: typeof WorkspaceSlugProjectsProjectIdIndexRoute
}

const WorkspaceSlugRouteChildren: WorkspaceSlugRouteChildren = {
  WorkspaceSlugCalendarRoute: WorkspaceSlugCalendarRoute,
  WorkspaceSlugIndexRoute: WorkspaceSlugIndexRoute,
  WorkspaceSlugBoardIndexRoute: WorkspaceSlugBoardIndexRoute,
  WorkspaceSlugDocsIndexRoute: WorkspaceSlugDocsIndexRoute,
  WorkspaceSlugFilesIndexRoute: WorkspaceSlugFilesIndexRoute,
  WorkspaceSlugMessagesIndexRoute: WorkspaceSlugMessagesIndexRoute,
  WorkspaceSlugMyTasksIndexRoute: WorkspaceSlugMyTasksIndexRoute,
  WorkspaceSlugProfileIndexRoute: WorkspaceSlugProfileIndexRoute,
  WorkspaceSlugProjectsIndexRoute: WorkspaceSlugProjectsIndexRoute,
  WorkspaceSlugTeamIndexRoute: WorkspaceSlugTeamIndexRoute,
  WorkspaceSlugTimeTrackerIndexRoute: WorkspaceSlugTimeTrackerIndexRoute,
  WorkspaceSlugProjectsProjectIdIndexRoute:
    WorkspaceSlugProjectsProjectIdIndexRoute,
}

const WorkspaceSlugRouteWithChildren = WorkspaceSlugRoute._addFileChildren(
  WorkspaceSlugRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  WorkspaceSlugRoute: WorkspaceSlugRouteWithChildren,
  DashboardRoute: DashboardRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  RegisterRoute: RegisterRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  InviteInviteIdRoute: InviteInviteIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
